import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListLocation } from "../../../components/Admin/Location";
import { useLanguage } from "../../../contexts";
import "./Location.scss";

export function Locations() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_locations"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListLocation active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_locations"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListLocation active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="location-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="location-page-header-wrapper">
        <div className="location-page-header">
          <span className="location-page-title">{t("locations")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
